module.exports = __webpack_public_path__ + "img/pic4.dc41c3f5.png";